// Brand tokens for Informed OS — keep in sync with index.css :root vars.
export const theme = {
  colors: {
    bg: '#0A0A0F',
    surface: '#13131A',
    surface2: '#1A1A22',
    text: '#F5F5F0',
    textSecondary: '#EDEDE8',
    textMuted: '#A1A1AA',
    accent: '#A78BFA',
    accentSoft: 'rgba(167, 139, 250, 0.15)',
    border: 'rgba(255, 255, 255, 0.08)',
    borderHover: 'rgba(167, 139, 250, 0.32)',
    tier: {
      ready: '#34D399',
      almost: '#FBBF24',
      improve: '#F97316',
      repair: '#EF4444',
    },
  },
  font: {
    display: "'Space Grotesk', 'Inter', sans-serif",
    body: "'Inter', sans-serif",
  },
};

export const APP_NAME = 'Informed OS';
export const APP_TAGLINE = 'Analyze. Repair. Prepare. Fund.';
